// extracted by mini-css-extract-plugin
export default {"wrapper":"SignupLayout_wrapper__Kh+3L","signup-box":"SignupLayout_signup-box__3bUgB","heart":"SignupLayout_heart__XWh8h"};